// extracted by mini-css-extract-plugin
export var wrapper = "TextMedia-module--wrapper--KNXNF";
export var content = "TextMedia-module--content--imtjy";
export var alignLeft = "TextMedia-module--align-left--KeB7O";
export var text = "TextMedia-module--text--3WOmn";
export var buttonWrapper = "TextMedia-module--button-wrapper--kW5rz";
export var media = "TextMedia-module--media--3aU1q";
export var podcast = "TextMedia-module--podcast--2gQQ_";
export var image = "TextMedia-module--image--1VzAY";
export var placeholder = "TextMedia-module--placeholder--2LCXp";